import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=21546091"
import script from "./Offset.vue?vue&type=script&lang=js"
export * from "./Offset.vue?vue&type=script&lang=js"
import style0 from "./Offset.vue?vue&type=style&index=0&id=21546091&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports